/*
 * IAMLIVIN Favorites — V1.0 browser-only implementation (localStorage).
 * Ingen backend/Admin API-skrivning nødvendig. Se sections/favorites-page.liquid
 * for arkitekturbeslutningen bag dette valg.
 *
 * Persistens: liste af product handles gemt under localStorage-nøglen
 * "iamlivin_favorites". Synkroniserer IKKE mellem enheder/browsere (kendt
 * V1.0-begrænsning, dokumenteret i PROJECT_CONTEXT.md).
 */
(function () {
  var STORAGE_KEY = 'iamlivin_favorites';

  function getFavorites() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveFavorites(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode etc.) — fail silently */
    }
  }

  function isFavorite(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var list = getFavorites();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveFavorites(list);
    return list.indexOf(handle) !== -1;
  }

  function updateButtonState(btn, active) {
    btn.setAttribute('data-favorited', active ? 'true' : 'false');
    btn.textContent = active ? '★ Gemt som favorit' : '☆ Tilføj til favoritter';
  }

  function initToggleButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-favorite-toggle]');
    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      updateButtonState(btn, isFavorite(handle));
      if (btn.getAttribute('data-favorite-bound') === 'true') return;
      btn.setAttribute('data-favorite-bound', 'true');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var nowActive = toggleFavorite(handle);
        updateButtonState(btn, nowActive);
        document.dispatchEvent(new CustomEvent('iamlivin:favorites-changed'));
      });
    });
  }

  function renderFavoritesList() {
    var container = document.querySelector('[data-favorites-list]');
    if (!container) return;

    var handles = getFavorites();
    if (handles.length === 0) {
      container.innerHTML = '<p style="opacity:0.7;">Du har ingen favoritter endnu — tilføj nogle nedenfor.</p>';
      return;
    }

    container.innerHTML = '<p style="opacity:0.6;">Indlæser...</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      container.innerHTML = '';
      var anyValid = false;

      products.forEach(function (product, i) {
        if (!product) return;
        anyValid = true;
        var handle = handles[i];
        var variant = product.variants[0];
        var price = (variant.price / 100).toFixed(2).replace('.', ',') + ' kr.';
        var img = product.featured_image || (product.images && product.images[0]) || '';

        var card = document.createElement('div');
        card.style.cssText =
          'display:flex; gap:14px; align-items:center; border:1px solid rgba(0,0,0,0.1); border-radius:8px; padding:14px 18px; flex-wrap:wrap;';

        var imgHtml = img
          ? '<img src="' + img + '&width=112" alt="" style="width:56px;height:56px;object-fit:cover;border-radius:4px;flex-shrink:0;">'
          : '';

        card.innerHTML =
          imgHtml +
          '<div style="flex:1; min-width:120px;">' +
            '<div style="font-weight:600;">' + product.title + '</div>' +
            '<div style="opacity:0.7; font-size:14px;">' + price + '</div>' +
          '</div>' +
          '<a href="/cart/' + variant.id + ':1" class="btn" style="white-space:nowrap;">Læg i kurv</a>' +
          '<button type="button" class="btn btn--secondary" data-favorite-toggle data-product-handle="' + handle + '" style="white-space:nowrap;"></button>';

        container.appendChild(card);
      });

      if (!anyValid) {
        container.innerHTML = '<p style="opacity:0.7;">De produkter, du har gemt som favoritter, findes ikke længere.</p>';
      }

      initToggleButtons(container);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initToggleButtons(document);
    renderFavoritesList();
  });

  document.addEventListener('iamlivin:favorites-changed', function () {
    renderFavoritesList();
  });
})();
